const ServicesCard = () => {
  return (
    <>
      {ServicesData.map((elem, index) => (
        <div className="card">
          <div className="flex justify-center items-center">
            <img src={elem.svg} alt="" />
          </div>
          <h2>{elem.heading}</h2>
          <p>{elem.desc}</p>
        </div>
      ))}
    </>
  );
};

export default ServicesCard;

const ServicesData = [
  {
    heading: `Logo Design`,
    desc: `We design professional, custom logos that make a lasting impression and work seamlessly across all platforms.`,
    svg: "logo_design.svg",
  },

  {
    heading: `Brand Identity`,
    desc: `We craft unique brand identities that connect with your audience and ensure consistency across all platforms.`,
    svg: "branding.svg",
  },

  {
    heading: `Brand Guidelines`,
    desc: `We create clear brand guidelines to ensure consistency across all platforms and communications.`,
    svg: "guidelines.svg",
  },

  {
    heading: `Wesite Design`,
    desc: `We design sleek, user-friendly websites that deliver a seamless experience and meet your goals.`,
    svg: "web_design.svg",
  },
];
